import { useRequiredContext } from "@redotech/react-util/context";
import ScalesIcon from "@redotech/redo-icons/scales-01.svg";
import ScalesFilledIcon from "@redotech/redo-icons/scales-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useConversionLockedAction } from "../../../../conversion/locked/use-conversion-locked-action";

export const AbTestItems = memo(function AbTestItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { locked, onLockedClick } = useConversionLockedAction(
    ScheduleDemoButtonLocation.NAV_AB_TESTS,
  );

  return (
    <RedoSecondaryNavItem
      action={
        locked
          ? { type: "button", onClick: onLockedClick }
          : { type: "link", href: routes.getConversionSubRoute("ab-tests") }
      }
      dimmed={locked}
      FilledIcon={ScalesFilledIcon}
      friendlyName="A/B tests"
      id="ab-tests"
      isPrivate={locked}
      UnfilledIcon={ScalesIcon}
    />
  );
});
